import { render, staticRenderFns } from "./ListeForfaits.vue?vue&type=template&id=365d18cc&scoped=true"
import script from "./ListeForfaits.vue?vue&type=script&lang=js"
export * from "./ListeForfaits.vue?vue&type=script&lang=js"
import style0 from "./ListeForfaits.vue?vue&type=style&index=0&id=365d18cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "365d18cc",
  null
  
)

export default component.exports